export class GarbageCollector {
  /**
   *
   * @type {(VoidFunction)[]}
   * @private
   * @memberof GarbageCollector
   */
  _collectors = [];

  constructor() {
    this._collectors = [];
  }

  /**
   * Добавляет функцию отписки в сборщик мусора
   *
   * @param {() => void} collector
   */
  add(collector) {
    this._collectors.push(collector);
  }

  /**
   * @param {(() => void)[]} collectors
   * @memberof GarbageCollector
   */
  addMany(collectors) {
    collectors.forEach(collector => this.add(collector));
  }

  /**
   * Высвобождает ресурсы
   *
   * @memberof GarbageCollector
   */
  release() {
    this._collectors.forEach(collector => collector());
  }
}
